import { rosterAPI } from '@/providers/apis/roster/roster';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'class-details',
})

export default class ClassDetails extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    private  filter: any = null;

    private classList: any = [];

    private currentPage: number = 1;


    // ---------------------------------------------------------------------------------
    // Hooks



    // ------------------------------------------------------------------------------
    // Methods

}
